<template>
  <section class="main-video">
    <div class="main-video__player">
      <el-dialog
        :visible.sync="dialogVisible"
        :lock-scroll="false"
        width="90%"
        center
      >
        <youtube-player v-if="dialogVisible" :id="youtubeVideoId" />
      </el-dialog>
      <div class="main-video__thumbs">
        <div class="main-video__thumbs-header">Watch Along</div>
        <flickity
          ref="flickity"
          :options="flickityOptions"
          class="main-video__flickity"
        >
          <div
            v-for="(item, i) in flickityItems"
            :key="item.id"
            class="main-video__thumb"
            @click="selectVideo(i)"
          >
            <div class="main-video__img-wrapper">
              <img :src="item.src" :alt="item.name" />
              <div class="main-video__controls">
                <a @click="playVideo(i)"><i class="el-icon-caret-right"/> Play Clip</a>
              </div>
            </div>
            <div class="main-video__thumb-name">{{ item.name }}</div>
          </div>
        </flickity>
      </div>
    </div>
  </section>
</template>

<script>
import Flickity from 'vue-flickity';
import PageMixin from '@/shared/pageMixin';
import YoutubePlayer from './YoutubePlayer';
import staticData from '@/config/globalConfigStaticData/landing_chappelle';

import trailer1 from '@/assets/images/chapelle/Trailer1.png';
import trailer2 from '@/assets/images/chapelle/Trailer2.png';
import trailer3 from '@/assets/images/chapelle/Trailer3.png';
import trailer4 from '@/assets/images/chapelle/Trailer4.png';
import trailer5 from '@/assets/images/chapelle/Trailer5.png';

export default {
  name: 'VideoMultiple',
  components: {
    Flickity,
    YoutubePlayer,
  },
  mixins: [PageMixin],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      trailerThumbs: [
        trailer5,
        trailer4,
        trailer3,
        trailer2,
        trailer1,
      ],
      currentVideoIndex: 0,
      dialogVisible: false,
    };
  },
  computed: {
    mainVideoSelected() {
      return this.value[this.currentVideoIndex];
    },
    youtubeVideoId() {
      return this.mainVideoSelected.id;
    },
    mainVideoQuote() {
      return this.mainVideoSelected.quote;
    },
    flickityItems() {
      return this.value.map((v, i) => ({
        ...v,
        src: this.trailerThumbs[i],
      }));
    },
    flickityOptions() {
      return {
        prevNextButtons: this.value.length > 1,
        draggable: true,
        contain: true,
        pageDots: false,
        wrapAround: false,
        setGallerySize: true,
      };
    },
  },
  watch: {

  },
  mounted() {
    this.$refs.flickity.on('select', this.onSelectVideo);
  },
  methods: {
    onSelectVideo(i) {
      this.currentVideoIndex = i;
    },
    selectVideo(i) {
      this.$refs.flickity.select(i);
    },
    handleCTAClick(btnId) {
      const { isFreeUser, isPremiumUser } = this.promoMeta;
      const routeTo = { path: '/signup' };
      if (isFreeUser) {
        routeTo.path = '/plans';
      } else if (isPremiumUser) {
        routeTo.path = staticData.podcastLink;
      }
      this.$analytics.track('Bespoke CTA Click', {
        screen_name: this.$route.name,
        path: this.$route.path,
        btnId,
      });
      this.$router.push(routeTo);
    },
    prevVideo() {
      if (this.currentVideoIndex) this.currentVideoIndex--;
    },
    nextVideo() {
      if (this.currentVideoIndex < this.value.length - 1) this.currentVideoIndex++;
    },
    playVideo(i) {
      this.selectVideo(i);
      this.dialogVisible = true;
    },
  },
};
</script>

<style lang='scss' scoped>
@import "../../../assets/scss/variables.scss";
@import "./mlp.scss";

.main-video {
  background-color: $mm-light-background-color;
  text-align: center;
  padding-top: 26px;
  padding-bottom: 86px;
  @media(max-width: $sm) {
    padding-top: 0;
    padding-bottom: 30px;
    background-color: $mm-almost-black;
    color: $mm-light-title-color;
  }
  &__quote {
    display: inline-block;
    margin: 0 26px 46px;
    font-size: 44px;
    line-height: 44px;
    text-align: center;
    letter-spacing: -1px;
    color: $mm-almost-black;
    @media (max-width: $sm) {
      margin: 0 26px 43px;
      font-size: 36px;
      line-height: 44px;
    }
  }
  &__hint {
    margin-top: 12px;
    text-align: left;
    font-weight: 500;
    font-size: 21px;
    line-height: 44px;
    letter-spacing: -1px;
    color: #000000;
    @media (max-width: $sm) {
      margin-top: 9px;
      margin-left: 25px;
      font-size: 14px;
      line-height: 24px;
    }
  }
  &__player {
    position: relative;
    margin: 0 auto;
    @media(max-width: 1786px) {
      margin-left: 253px;
      margin-right: 253px;
    }
    @media(max-width: 1280px) {
      width: 774px;
      margin: 0 auto;
    }
    @media(max-width: 774px) {
      width: 100%;
    }
    @media(max-width: $xs) {
      padding: 0;
      margin: 0;
    }
  }
  &__thumbs {
    padding-left: 0;
    padding-right: 0;
    @media(max-width: 820px) {
      padding-left: 35px;
      padding-right: 35px;
    }
  }
  &__thumbs-header {
    @include mlp-title;
    margin: 44px 0 17px;
    color: $mm-almost-black;
    @media(max-width: $xs) {
      margin: 20px 0 17px;
      color: #F3F1D5;
    }
  }
  &__thumb {
    width: calc(33% - 10px);
    opacity: 0.5;
    transition: opacity 0.5s ease;
    margin-left: 10px;
    margin-right: 10px;
    @media(max-width: $sm) {
      width: calc(50% - 10px);
    }
    @media(max-width: $xs) {
      width: calc(100% - 10px);
    }
    img {
      width: 100%;
    }
    &.is-selected {
      opacity: 1;
      transition: opacity 0.5s ease;
    }
    &:first-child {
      .main-video__img-wrapper {
        margin-left: 0;
      }
      .main-video__thumb-name {
        margin-left: 0;
      }
    }
    &:last-child {
      .main-video__img-wrapper {
        margin-right: 0;
      }
    }
  }
  &__thumb-name {
    margin-bottom: 10px;
    text-align: left;
  }
  &__img-wrapper {
    box-sizing: border-box;
    height: 0;
    padding-bottom: 56%;
    overflow: hidden;
    position: relative;
  }
  &__current-video {
    color: $mm-light-title-color;
    font-weight: 500;
    font-size: 14px;
    line-height: 24px;
    text-align: left;
    flex: 1 1 auto;
  }
  &__mobile-btn-container {
    flex: 0 0 60px;
  }
  &__mobile-btn {
    cursor: pointer;
    outline: none;
    background-color: #fff !important;
    width: 30px;
    height: 30px;
    opacity: 0.9;
    box-shadow: 0px 8px 10px rgba(0, 0, 0, 0.14), 0px 3px 14px rgba(0, 0, 0, 0.12), 0px 5px 5px rgba(0, 0, 0, 0.2);
    transition: .2s all ease-in-out;
    border-radius: 50%;
    border: 0;
    position: relative;
    svg {
      position: absolute;
      left: 20%;
      top: 20%;
      width: 60%;
      height: 60%;
    }
    svg.prev-btn {
      transform: rotate(90deg);
    }
    svg.next-btn {
      transform: rotate(-90deg);
    }
  }
  &__flickity /deep/ .flickity-button {
    top: 45%;
  }
  &__controls {
    position: absolute;
    width: 100%;
    height: 40px;
    bottom: 0;
    background-color: rgba(0,0,0, 0.37);
    text-align: left;
    a {
      margin-left: 14px;
      color: #fff;
      cursor: pointer;
      line-height: 40px;
      font-size: 16px;
    }
  }
  .regular-btn {
    height: 40px;
    background: $mm-dark-background;
    border-radius: 38px;
    text-transform: uppercase;
    font-size: 15px;
    line-height: 1;
    padding: 0 23px;
    border: 1px solid $mm-dark-background;
    transition: .1s;
    color: $mm-light-title-color;
    outline:none;
    cursor: pointer;
    &:hover {
      background-color: transparentize($mm-dark-background, 0.3);
    }
    &:active {
      background-color: $mm-dark-color;
    }
    &.disablable[disabled] {
      cursor: auto;
      background-color: Silver;
      &:hover {
        background-color: Silver;
      }
      &:active {
        background-color: Silver;
      }
    }
  }
  .square-btn {
    border-radius: 0;
  }
}
</style>
